import React from "react";
import { primaryHighlightIcon } from "../../utils/europe-highlights";
import { MAP_SELECTION_GLOW } from "../../utils/map-selection-glow";
import type { HighlightActivity } from "../../types/europe-highlights";

interface HighlightMarkerProps {
  activities: HighlightActivity[];
  title: string;
  onClick: () => void;
  onMouseOver: () => void;
  onMouseOut: () => void;
  isSelected?: boolean;
}

/**
 * Same icon language as verified PointMarker, but grayed-out when unverified.
 * Selected places use the shared orange glow.
 */
const HighlightMarker: React.FC<HighlightMarkerProps> = ({
  activities,
  title,
  onClick,
  onMouseOver,
  onMouseOut,
  isSelected = false,
}) => {
  const icon = primaryHighlightIcon(activities);
  const size = isSelected ? 24 : 16;

  return (
    <img
      src={`/images/icons/${icon}.svg`}
      alt={title}
      title={title}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        position: "absolute",
        top: "0px",
        left: "0px",
        cursor: "pointer",
        pointerEvents: "auto",
        filter: isSelected
          ? `grayscale(0.35) contrast(0.95) ${MAP_SELECTION_GLOW}`
          : "grayscale(1) contrast(0.8) opacity(0.85)",
        borderRadius: isSelected ? "50%" : "0",
        zIndex: 0,
      }}
    />
  );
};

export default React.memo(HighlightMarker);
